import { render, staticRenderFns } from "./AddAdminAnnouncement.vue?vue&type=template&id=29b5b96a&scoped=true&"
import script from "./AddAdminAnnouncement.vue?vue&type=script&lang=js&"
export * from "./AddAdminAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b5b96a",
  null
  
)

export default component.exports